export default __webpack_public_path__ + "static/media/pelicana.31ab8598.jpeg";